import { useState, useCallback } from 'react';
import { Auth } from 'aws-amplify';

const ApiRequestV2 = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async (endpoint, data = {}) => {
    setIsLoading(true);
    setResponse(null);
    setError(null);

    try {
      const user = await Auth.currentAuthenticatedUser();
      const idToken = "Bearer " + user.signInUserSession.idToken.jwtToken;

      const url = `https://852t0urirb.execute-api.ap-northeast-1.amazonaws.com/v2/${endpoint}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': idToken,
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (response.ok) {
        setResponse(responseData);
        return responseData; // 戻り値を設定
      } else {
        const errorMsg = `API Request Error: ${response.status} ${response.statusText}`;
        setError(errorMsg);
        throw new Error(errorMsg);
      }
    } catch (error) {
      let errorMsg = 'API Request Error: ';
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        errorMsg = 'ネットワークエラーが発生しました。インターネット接続を確認してください。';
      } else {
        errorMsg = error.message;
      }
      console.error('API Request Error:', errorMsg);
      setError(errorMsg);
      throw new Error(errorMsg); // エラーを再スロー
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { response, error, isLoading, fetchData };
};

export default ApiRequestV2;
